Covidence.Plan = Backbone.RelationalModel.extend({});

Covidence.Plans = Covidence.Collection.extend({
  model: Covidence.Plan,

  remote: true,
});
